import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from 'styles/theme';

interface CardProps {
  children: ReactNode;
}

const Card: React.FC<CardProps> = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Card;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: ${theme.colors.secondary};
  border-radius: ${theme.dimensions.card.borderRadius};
  padding: 1.5rem 1rem;

  width: 100%;
  max-width: ${theme.dimensions.card.width};
`;
